import React from 'react';
import { Select, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useGet } from '../../../hooks/useApi';
import { Student } from '../../../models/student.model';

interface StudentSelectorProps {
  value: number | null;
  onChange: (studentId: number | null) => void;
  placeholder?: string;
}

const StudentSelector: React.FC<StudentSelectorProps> = ({
  value,
  onChange,
  placeholder = 'Select student',
}) => {
  const { data: students, isLoading } = useGet<Student[]>(
    '/v1/auth/dashboard/students'
  );

  if (isLoading) {
    return (
      <Select
        placeholder={placeholder}
        style={{ width: '100%' }}
        notFoundContent={<Spin size="small" />}
        loading
      />
    );
  }

  const options = (students || []).map((student: Student) => ({
    value: student.id,
    label: (
      <span>
        <UserOutlined style={{ marginRight: 8 }} />
        {student.firstName} {student.lastName}
      </span>
    ),
    title: `${student.firstName} ${student.lastName}`, // For tooltip
  }));

  return (
    <Select
      placeholder={placeholder}
      style={{ width: '100%' }}
      value={value}
      onChange={onChange}
      allowClear
      showSearch
      optionFilterProp="title"
      filterOption={(input, option) =>
        (option?.title?.toLowerCase().indexOf(input.toLowerCase()) ?? -1) >= 0
      }
      options={options}
      notFoundContent={
        (students || []).length === 0
          ? 'No students found'
          : 'No matching students'
      }
    />
  );
};

export default StudentSelector;
